import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link} from 'react-router-dom'


// import icons
import {HiOutlineLocationMarker} from 'react-icons/hi'

import img11 from '../../Assets/signImg/img11.jpeg'

const Data = [
    {
        id:11,
        imgSrc: img11,
        destTitle: '古今輝映 - 東亞的悠久與新興',
        location: '日本 · 台灣',
        grade: '12-19',
        fees:'3990 美元',
        description:'承襲盛唐遺風的世界文化遺產，孕育出風靡全球的二次元文化，日本如何成為動漫王國？而純樸而充滿活力的台灣，又是如何在全球半導體與電子製造業中獨占鰲頭？'
      },
  ]

export default function Signature11() {

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

  return (
<section className='signMain signContainer signSection '>
    <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
           古 今 輝 映 - 東 亞 的 悠 久 與 新 興
        </h3>
        <button className='signHomeBtn'><Link to={'/'} className='signHomeBtnLink'>返回首頁</Link></button>
    </div>

    <div className='signSecContent signGrid'>
        { 
            Data.map(({id, imgSrc, destTitle, location, company, fees, description})=>{

                return(
                <div key={id} data-aos='fade-up' className='signSingleDestination'>
                    
                    <div className='signCardInfo'>
                        <h4 className='signDestTitle'>{destTitle}</h4>
                        <span className='signContinent signFlex'>
                        <HiOutlineLocationMarker className='icon' />
                            <span className='signName'>{location}</span>
                        </span>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                <span>
                                {/* 执行机构：{company} */}
                                    <br/>
                                    <small>⭐️ 行 程 精 華 ⭐️</small>
                                    <br/><br/>
                                </span>
                            </div>
                        <div>
                        <br/><p><b>{description}</b></p><br/>
                                
                                <table width='100%'>
                                    <thead>
                                        <tr>
                                            <th width='10%'></th>
                                            <th width='10%'></th>
                                            <th width='80%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                         <tr>
                                            <td>文化遺蹟</td>
                                            <td>     </td>
                                            <td>源自盛唐，明宋時期的建築與文物，在日本、台灣，被完整繼承；
                                            </td>
                                            
                                        </tr><br/>
                                        <tr>
                                            <td>社會自然</td>
                                            <td></td>
                                            <td>日本特有風格的動畫和漫畫；台灣的休閒、市民文化</td>

                                        </tr><br/>
                                        <tr>
                                            <td>產業先鋒</td>
                                            <td></td>
                                            <td>半導體與電子產業的重鎮；豐田產業技術館</td>

                                        </tr><br/>
     

                                    </tbody>
                                </table>
                            </div>
                            

                        </div>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                        <span>
                                            <small>⭐️ 參 團 資 訊 ⭐️</small>
                                        </span>
                                        <br/><br/>
                            </div> <br/>
                            <table width='100%'>
                                    <thead>
                                        <tr>
                                            <th width='15%'></th>
                                            <th width='10%'></th>
                                            <th width='75%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>參團年齡</td>
                                            <td>     </td>
                                            <td>14-21歲學生</td>
                                        </tr><br/>
                                        <tr>
                                            <td>適合人群</td>
                                            <td>     </td>
                                            <td>華語學習者，希望了解東亞文化；喜歡日本漫畫動畫；願意品嚐日餐和華餐夜市小吃</td>
                                        </tr><br/>
                                        <tr>
                                            <td>時間安排</td>
                                            <td>     </td>
                                            <td>8月「為期24天」</td>
                                        </tr><br/>
                                        <tr>
                                            <td>地 點</td>
                                            <td>     </td>
                                            <td>日本 · 台灣</td>
                                        </tr><br/>
                                        <tr>
                                            <td>费 用 包 括</td>
                                            <td>     </td>
                                            <td>在日本/台灣的參觀學習費用，餐飲費用，住宿費用，交通費用，門票費用；
                                            </td>
                                        </tr><br/>
                                        <tr>
                                            <td>費用不包含</td>
                                            <td>     </td>
                                            <td>
                                                國際旅行手續費、往返國際機票、台日之間旅費、國際旅行醫療保險、意外保險、個人購物、個人消費。
                                            </td>
                                        </tr><br/>
                                    </tbody>
                            </table>
                        </div>

                    <div className='signFees'>
                        <div className='signGrade'>
                                    <span>
                                        <small>⭐️ 參 考 行 程 ⭐️</small>
                                    </span>
                                    <br/><br/>
                        </div>
                        <br/>
                        <h6>行程範例</h6>
                        <p>實際活動內容可能會有前後調整，或被相近內容替代；夏令營正式開始前四週確定行程細節。</p>
                        <br/>
                        <table width='100%'>
                                        <thead>
                                            <tr>
                                                <th width='20%'>日  期</th>
                                                <th width='40%'>上 午 活 動</th>
                                                <th width='40%'>下 午 活 動</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <br/>
                                            <tr>
                                                <td>第一日</td>
                                                <td>出發</td>
                                                <td>抵達台灣休息</td>
                                            </tr>
                                            <tr>
                                                <td>第二日</td>
                                                <td>遊覽台北故宮</td>
                                                <td>遊覽總統府 / 品嚐夜市</td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第三日</td>
                                                <td>台北龍山寺 /</td>
                                                <td>台灣大學</td>
                                            </tr>
                                            <tr>
                                                <td>第四日</td>
                                                <td>台積電</td>
                                                <td>宏碁 / 華碩</td>
                                            </tr>
                                            <tr>
                                                <td>第五日</td>
                                                <td>新北平溪火車</td>
                                                <td>至花蓮</td>
                                            </tr>
                                            <tr>
                                                <td>第六日</td>
                                                <td>花蓮七星潭</td>
                                                <td>太魯閣Hiking</td>
                                            </tr>
                                            <tr>
                                                <td>第七日</td>
                                                <td>至台東</td>
                                                <td>台東熱氣球嘉年華 / 卑南遺址公園 / 夜市</td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第八日</td>
                                                <td>台東三仙台 / 小野柳</td>
                                                <td>至嘉義</td>
                                                {/* <td>台東- -首爾</td>
                                                <td>台東- -首爾</td> */}
                                            </tr>
                                            <tr>
                                                <td>第九日</td>
                                                <td>嘉義-阿里山</td>
                                                <td>阿里山-嘉義</td>
                                                {/* <td>首爾景福宮</td>
                                                <td>北村韓屋村</td> */}
                                            </tr>
                                           
                                            <tr>
                                                <td>第十日</td>
                                                <td>嘉義-台北</td>
                                                <td>嘉義-台北</td>
                                                {/* <td>遊覽MBC K-Drama基地</td>
                                                <td>K-pop Dance training / Hair-Style </td> */}
                                            </tr>
                                            <tr>
                                                <td>第十一日</td>
                                                <td>台北 - 東京</td>
                                                <td>東京 秋葉原Animate店 / 遊戲中心</td>
                                            </tr>
                                            <tr>
                                                <td>第十二日</td>
                                                <td>東京迪士尼樂園</td>
                                                <td>東京迪士尼樂園</td>
                                            </tr>
                                            <tr>
                                                <td>第十三日</td>
                                                <td>東京吉普力美術館</td>
                                                <td>東京國立博物館</td>
                                            </tr>
                                            <tr>
                                                <td>第十四日</td>
                                                <td>富士山漫步</td>
                                                <td>富士山漫步</td>
                                            </tr>
                                            <tr>
                                                <td>第十五日</td>
                                                <td>富士山-京都</td>
                                                <td>東映泰映畫村漫畫館</td>
                                            </tr>
                                            <tr>
                                                <td>第十六日</td>
                                                <td>金閣寺</td>
                                                <td>二條城</td>
                                            </tr>
                                            <tr>
                                                <td>第十七日</td>
                                                <td>京都-奈良</td>
                                                <td>奈良鹿園 / 法隆寺</td>
                                            </tr>
                                            <tr>
                                                <td>第十八日</td>
                                                <td>大阪環球影城</td>
                                                <td>大阪環球影城</td>
                                            </tr>
                                            <tr>
                                                <td>第十九日</td>
                                                <td>大阪世博會</td>
                                                <td>大阪世博會</td>
                                            </tr>
                                            <tr>
                                                <td>第二十日</td>
                                                <td>大阪-東京</td>
                                                <td>大阪-東京</td>
                                            </tr>
                                            <tr>
                                                <td>第二十一日</td>
                                                <td>東京同人展</td>
                                                <td>東京同人展</td>
                                            </tr>
                                            <tr>
                                                <td>第二十二日</td>
                                                <td>返程</td>
                                                <td>回到溫暖的家</td>
                                            </tr>
                                        </tbody>
                            </table>

                            <div className='signGrade'>
                        <span>
                            <small>⭐️ 課 程 和 活 動 說 明 ⭐️</small>
                        </span>
                             <br/><br/>
                    </div> 
                            <br/>
                        
                        <h6>每日活動內容包括但不限於（最終的行程，由以下活動的其中一部分組成）：</h6>
                        <p>
                            <b>歷史古蹟：</b>
                            金閣寺；二條城；大阪城；熱田神宮；名古屋城；法隆寺；東大寺；藥師寺；龍山寺；
                            <br/>
                            <b>主題公園：</b>
                            大阪環球影城；東映泰映畫村；名古屋水族館；新北平溪火車；
                            <br/>
                            <b>博物展館：</b>
                           吉普力美術館；東京國立博物館；豐田產業技術紀念館；台灣總統府；台北故宮；
                            <br/>
                            <b>社會與自然：</b>
                            東京夏季同人展；台東熱氣球嘉年華；富士山漫步；奈良鹿園；池袋手辦商業區；漫畫咖啡館；士林夜市；太魯閣漫步；台北101；
                            <br/>
                        </p>
                    </div>
                    
                        <div className='signPrice'>
                            <h5>预 售 价 格 ：{fees}</h5>
                        </div>
                        <Link to={"/formReg"} target="_blank">
                        <button className='signBtn signFees'>
                            <h4>⭐️ ⭐️ ⭐️  預 約 報 名 - 搶 先 卡 位  ⭐️ ⭐️ ⭐️</h4>
                         </button>
                         </Link>
                </div>
                    <div className='signImageDiv'>
                        <img src={imgSrc} alt={destTitle}/>
                    </div>

                </div>
                )
            })
        
        }
       
    </div>

</section>
  )
}
